import React, { ReactNode, useState } from 'react';

import { Indexable } from 'src/interfaces/interfaces';

import './NestedTableRow.scss';

interface NestedTableRowProps {
    data: Indexable;
    innerTable?: ReactNode | undefined;
    keys: Array<string>;
}

export default function NestedTableRow({ data, innerTable, keys }: NestedTableRowProps) {
    enum ArrowStyle {
        Right = 'keyboard_arrow_right',
        Down = 'keyboard_arrow_down',
    }

    const [shouldShowInnerTable, setShouldShowInnerTable] = useState(false);
    const [arrowStyle, setArrowStyle] = useState(ArrowStyle.Right);

    const handleShowInnerTableClick = () => {
        setShouldShowInnerTable(!shouldShowInnerTable);
        setArrowStyle(!shouldShowInnerTable ? ArrowStyle.Down : ArrowStyle.Right);
    };

    const getCellValue = (obj: Indexable, key: string) => (obj[key] ? obj[key] : '');
    const classes = ['nested-table-row'];
    const colspan = keys?.length + 1;
    let rowContent: React.ReactNode = <></>;

    // NOTE: https://youtu.be/U9uWSHWcHag?t=30
    const cells = (
        <>
            {keys.map((key, x) => (
                <td className="nested-table__cell" key={x}>
                    {getCellValue(data, key)}
                </td>
            ))}
        </>
    );

    if (innerTable) {
        classes.push('nested-table-row--expandable');

        rowContent = (
            <table>
                <tbody>
                    <tr>
                        <td className="nested-table__cell">
                            <button type="button" onClick={handleShowInnerTableClick}>
                                <span className="material-icons">{arrowStyle}</span>
                            </button>
                        </td>
                        {cells}
                    </tr>
                </tbody>
            </table>
        );
    } else {
        rowContent = cells;
    }

    return (
        <tr className={classes.join(' ')}>
            {!innerTable && rowContent}
            {innerTable !== undefined && (
                <td colSpan={colspan}>
                    {rowContent}
                    {shouldShowInnerTable && innerTable}
                </td>
            )}
        </tr>
    );
}

NestedTableRow.defaultProps = {
    data: {},
    innerTable: undefined,
    keys: [],
};
